export default function getColorBySpeed(speed: number): string {
  if (speed < 0) return "#FFFFFF"; // 假设负数为 No Data
  if (speed < 20) return "#8F8FFF"; // Very Low (<20 m/s)
  if (speed < 25) return "#9CBBFF"; // Low (20-25 m/s)
  if (speed < 30) return "#9CDEFF"; // Low (25-30 m/s)
  if (speed < 35) return "#80FFFF"; // Moderate (30-35 m/s)
  if (speed < 40) return "#C7FFDF"; // Moderate (35-40 m/s)
  if (speed < 50) return "#FFFF99"; // Significant (40-50 m/s)
  if (speed < 60) return "#FFDD99"; // High (50-60 m/s)
  if (speed < 70) return "#FFBB99"; // Very High (60-70 m/s)
  return "#FF9999"; // Extreme (>70 m/s)
}
